import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import * as admin from '@vectronic/openApi-admin';
import { BACKEND_HOST } from './backend-host.injection';

export const backendHostInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const backendHost = inject(BACKEND_HOST) ?? '';
  const fakturaRestInterfaceBasePath = inject(admin.fakturaApi.BASE_PATH, { optional: true });
  const internalSmbServiceBasePath = inject(admin.smbApi.BASE_PATH, { optional: true });
  if (
    backendHost.length === 0 ||
    req.url.startsWith('/assets') ||
    req.url.startsWith('https://') ||
    req.url.startsWith('http://') ||
    (fakturaRestInterfaceBasePath && req.url.startsWith(fakturaRestInterfaceBasePath)) ||
    (internalSmbServiceBasePath && req.url.startsWith(internalSmbServiceBasePath))
  ) {
    return next(req);
  }
  return next(req.clone({ url: backendHost + req.url }));
};
